import { differenceInYears } from 'date-fns'
import * as _ from 'lodash'

import { getAirportNames } from '../../data/models/funnelOrder/airport'
import { getPlaceholder as getDestPlaceholder } from '../../data/models/funnelOrder/destination'
import { getPlaceholder } from '../../data/models/funnelOrder/roomType'
import { getThemeId } from '../../data/models/funnelOrder/theme'
import { getValueForIncomingTime } from '../../data/models/funnelOrder/times'
import { deliveryStyle } from '../../data/models/giftcardOrder'
import { AppState } from '../../data/state'
import { store } from '../../store/store'

import { FunnelOrder } from '../../data/models/funnelOrder'
import { getSiteCurrencyISO, SiteCurrency } from '../../data/models/locale'
import { DateFormatType, format } from '../../utils/date'
import { IGiftcardTrackingData } from './models/IGiftcardTrackingData'

export function getExtras(funnelOrder: FunnelOrder) {
  const crossSellItems: any[] = []
  const keys = [
    'includeBreakfast',
    'travelInsurance',
    'cancellationInsurance',
    'privateRoom',
    'arrangeTransfer',
    'babyCrib',
  ]
  keys.forEach(key => {
    if ((funnelOrder as any)[key]) {
      crossSellItems.push({
        name: key,
        category: 'cross-sell',
        price: (funnelOrder.crossSellPrices as any)[key],
        quantity: 1,
      })
    }
  })
  if (funnelOrder.numberOfBags > 0) {
    crossSellItems.push({
      name: 'extraLuggage',
      category: 'cross-sell',
      price: funnelOrder.crossSellPrices.extraLuggage,
      quantity: funnelOrder.numberOfBags,
    })
  }
  return crossSellItems
}

export function getFunnelRequiredDetails(state: AppState) {
  return {
    total_value: state.funnelOrder.total,
    currency: getSiteCurrencyISO(state.locale.currency || SiteCurrency.euro),
    country: state.locale.country,
    trip_id: getThemeId(state.funnelOrder.theme),
    trip_type: 'City Break',
    category: 'trips',
    departure_date: format(
      new Date(state.funnelOrder.departureDate!),
      DateFormatType.apidate,
    ),
    people:
      state.funnelOrder.numberOfAdults +
      state.funnelOrder.numberOfChildren +
      state.funnelOrder.numberOfBabies,
    adults: state.funnelOrder.numberOfAdults,
    children: state.funnelOrder.numberOfChildren,
    babies: state.funnelOrder.numberOfBabies,
    coupon: state.funnelOrder.discountCode
      ? state.funnelOrder.discountCode.code
      : undefined,
  }
}

export function getFunnelStep1Details(state: AppState) {
  return {
    departure_airport: getAirportNames(
      state.funnelOrder.airports,
      state.locale.country,
    ),
    departure_time: getValueForIncomingTime(state.funnelOrder.incomingTime),
    destination: getDestPlaceholder(state.funnelOrder.destination),
    accomodation: getPlaceholder(state.funnelOrder.roomType),
    days: state.funnelOrder.days,
  }
}

export function getIdentityTrackingDetails() {
  const state: AppState = Object.assign({}, store.getState())
  const { funnelOrder } = state

  return {
    email: funnelOrder.travelers[0].Email,
    name: `${funnelOrder.travelers[0].Forename} ${funnelOrder.travelers[0].LastName}`,
    phone: funnelOrder.travelers[0].Telephonenumber,
    age:
      funnelOrder.travelers[0].DateOfBirth !== undefined
        ? differenceInYears(
            new Date(),
            new Date(funnelOrder.travelers[0].DateOfBirth || 0),
          )
        : 0,
    gender: funnelOrder.travelers[0].Gender,
  }
}

export function getGiftcardTrackingDetails(
  transactionId?: string,
): IGiftcardTrackingData {
  const state: AppState = Object.assign({}, store.getState())

  const deliveryStyleMap = new Map([
    [deliveryStyle.sendToSender, 'Giftcards they give'],
    [deliveryStyle.sendToReceiver, 'Giftcard we post'],
  ])

  return {
    transaction_id: transactionId,
    total_value: _.sumBy(state.giftcardOrder.giftcards, 'amount'),
    currency: getSiteCurrencyISO(state.locale.currency || SiteCurrency.euro),
    trip_id: 50,
    trip_type:
      deliveryStyleMap.get(state.giftcardOrder.deliveryStyle) || 'giftcards',
    category: 'gift',
    country: state.locale.country,
    coupon: state.funnelOrder.discountCode
      ? state.funnelOrder.discountCode.code
      : undefined,
  }
}

export function getGiftcardIdentityTrackingDetails() {
  const state: AppState = store.getState()

  return { email: state.giftcardOrder.email }
}
